import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
// 公共样式
import "./assets/css/style.scss";
// swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// 饿了么
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 防止快速点击重复调用接口
import preventReClick from "@/assets/js/preventReClick";
/* 全局基础样式 、全局字体图标 */
import './assets/css/global.css'
/* 主题颜色 */
import './assets/css/mixin.scss'
// /* 备课样式 */
// import './assets/css/ready-course/style.scss'
// /* 授课样式 */
// import './assets/css/give-course/style.scss'
// 公共样式
import "./assets/css/style.scss";
import "./assets/iconfont/iconfont.css";
import './assets/iconfont/iconfont.js'
Vue.prototype.$previewPath = process.env.VUE_APP_API_BASE_URL + "/preview/";

//md5加密
import md5 from "js-md5";
//Highcharts图表
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import highcharts3d from "highcharts/highcharts-3d";
highcharts3d(Highcharts);
Vue.use(HighchartsVue);
import { formatDate } from "./common/date";
//导入按钮防抖
import { noMultipleClicks } from "./common/no-multiple-clicks";
import { isEmptyObj } from "./common/common.js";
import * as echarts from "echarts";
import scroll from "vue-seamless-scroll"
Vue.use(scroll)
// vuex
import Vuex from "vuex";
import store from "./store";
/* 滑动验证码 */
import SlideVerify from "vue-monoplasty-slide-verify";
import ECharts from 'vue-echarts'
import 'echarts-liquidfill'
import VueSimpleVerify from 'vue-simple-verify'
import '../node_modules/vue-simple-verify/dist/vue-simple-verify.css'
//视频插件
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs
Vue.component('vue-simple-verify', VueSimpleVerify)
/* 滑动验证码 */
Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD';
  return moment(value).format(formatString);
});
/* 删除提示 */
Vue.prototype.delMsg = function (res, msg = "此操作将永久删除该数据, 确定要删除吗?") {
  this.$confirm(msg, "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      res()
    })
    .catch(() => {
      // this.$message({
      //   type: "info",
      //   message: "已取消删除",
      // });
    });
}
Vue.use(ElementUI);
Vue.use(preventReClick);
Vue.component('v-chart', ECharts)
Vue.use(Vuex);
Vue.use(VueAwesomeSwiper);
Vue.use(SlideVerify);
Vue.prototype.$TimeData = formatDate;
Vue.prototype.$noMultipleClicks = noMultipleClicks;
Vue.prototype.$isEmptyObj = isEmptyObj;
Vue.config.productionTip = false;
window._CONFIG = {};
window._CONFIG._URL = {};
Vue.prototype.$md5 = md5;

new Vue({
  strict: false,
  router,
  store,
  render: h => h(App),
}).$mount("#app");
